export default __webpack_public_path__ + "static/media/slider4.2ef7973d.jpg";